import React, { useState } from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { currentPageReportTemplate, onPageChange, paginatorTemplate, rowsPerPageOptions } from "../../../utilities/TableUtil";
import { normalColumn, imageColumnClick } from "../../../components/DataTable/DataTable.js";
import * as bodyStyle from "../../../components/DataTable/ConsBodyStyle.js";

export default function P203List_2({ dataTable, viewImage }) {
    const [pageConf, setPageConf] = useState({ first: 0, rows: 10 });
    return (
        <div className="datatable-responsive-modify">
            <div className="card">
                <DataTable
                    // ref={(el) => dt = el}
                    value={dataTable}
                    dataKey="id"
                    paginator
                    first={pageConf.first}
                    rows={pageConf.rows}
                    onPage={(e) => onPageChange(e, setPageConf)}
                    rowsPerPageOptions={rowsPerPageOptions()}
                    paginatorTemplate={paginatorTemplate()}
                    currentPageReportTemplate={currentPageReportTemplate()}
                    emptyMessage="ยังไม่ได้เพิ่มรายการ"
                    className="p-datatable-gridlines p-datatable-sm p-datatable-responsive-modify"
                    selectionMode="single"
                >
                    <Column sortable field="seqPk" header="รูปที่" body={(e) => normalColumn(e, "seqPk", "รูปที่")} style={{ textAlign: "center", width: "6%" }} bodyStyle={bodyStyle.TXT_CENTER} />
                    <Column field="photoDesc" header="รายละเอียดรูป" body={(e) => normalColumn(e, "photoDesc", "รายละเอียดรูป")} style={{ textAlign: "center", width: "6%" }} bodyStyle={bodyStyle.TXT_OVER} />
                    <Column field="photoPath" header="รูปถ่าย" body={(e) => imageColumnClick(e, "photoPath", "รูปถ่าย", viewImage)} style={{ textAlign: "center", width: "10%" }} bodyStyle={bodyStyle.TXT_CENTER} />
                </DataTable>
            </div>
        </div>
    );
}
